import Svg, { SvgProps } from './Svg';

export default function PieIcon({
  color = 'url(#primarygradient)',
  ...props
}: SvgProps) {
  return (
    <Svg
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}>
      <defs>
        <linearGradient id="primarygradient">
          <stop offset="0%" stopColor="#fa43bd" />
          <stop offset="100%" stopColor="#ffcd4d" />
        </linearGradient>
      </defs>
      <path d="M21 12c.552 0 1.005-.449.95-.998a10 10 0 0 0-8.953-8.951c-.55-.055-.998.398-.998.95v8a1 1 0 0 0 1 1z"></path>
      <path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path>
    </Svg>
  );
}
